import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import {
  salesHeaderTyps1,
  salesHeaderTyps2,
} from '../../utils/forecastStaticData';
import { getNumberComma } from '../../utils/numberUtils';

const SalesStaticTableCell = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    headerRows &&
    headerRows.map((field, fIndex) => {
      return field?.val !== 'sp'
        ? salesHeaderTyps1.map((type, tIndex) => {
            let key = `${fIndex}_${tIndex}`;

            let value = _.has(data, `${field.val}.${type.id}`)
              ? data[field.val][type.id]
              : '-';
            // let formatValue =
            //   type.id !== 'achiveRate' ? getNumberComma(value) : value;

            return (
              <TableCell
                sx={{ width: '100px', paddingLeft: 0 }}
                align="right"
                key={key}
              >
                {getNumberComma(value)}
              </TableCell>
            );
          })
        : salesHeaderTyps2.map((type, tIndex) => {
            let key = `${fIndex}_${tIndex}`;

            let value = _.has(data, `${field.val}.${type.id}`)
              ? data[field.val][type.id]
              : '-';
            let formatValue =
              type.id !== 'achiveRate' ? getNumberComma(value) : value;

            return (
              <TableCell
                sx={{ width: '100px', paddingLeft: 0 }}
                align="right"
                key={key}
              >
                {formatValue}
              </TableCell>
            );
          });
    })
  );
};

export default SalesStaticTableCell;
